export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/DxfViewerWorker.b49c3132.worker.js");
}
